import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./styles/AllServicesPage.css";

// ── Icons ────────────────────────────────────────────────────────
import CloudITSolutions         from "../../assets/images/services/Cloud-IT-Solutions.png";
import AIandAutomation           from "../../assets/images/services/AI-and-Automation.png";
import CyberSecurity             from "../../assets/images/services/Cyber-Security.png";
import StrategicITConsulting     from "../../assets/images/services/Strategic-IT-Consulting.png";
import NetworkSolutions          from "../../assets/images/services/Network-Solutions.png";
import ITSupportService          from "../../assets/images/services/IT-Support-Service.png";
import designIcon                from "../../assets/images/services/Design-and-Deployment.png";
import auditIcon                 from "../../assets/images/services/Network-Audit.png";
import strategyIcon              from "../../assets/images/services/Business-Strategy.png";
import recruiterIcon             from "../../assets/images/services/Technical-recruiter.png";
import supportIcon               from "../../assets/images/services/Support-Training.jpg";
import colocationIcon            from "../../assets/images/services/Help-finding-ideal-colocation.jpg";
import DataCenterColocation      from "../../assets/images/services/Data-Center-Colocation-Services.png";
import ConfigDeployment          from "../../assets/images/services/Configuration-Services-Deployment.png";
import cloudConsulting           from "../../assets/images/services/cloud consulting.png";
import CybersecurityConsulting   from "../../assets/images/services/Cybersecurity Consulting.png";
import InfrastructureConsulting  from "../../assets/images/services/Infrastructure Consulting.png";
import DigitalTransformation     from "../../assets/images/services/Digital Transformation.png";
import ImplementationServices    from "../../assets/images/services/Implementation Services.png";

// ── Data ─────────────────────────────────────────────────────────
const TABS = [
  { key: "managed",                  code: "MS · 01", label: "Managed Services" },
  { key: "infra",                    code: "IS · 02", label: "Infrastructure Services" },
  { key: "ITConsulting&Professional",code: "CS · 03", label: "IT Consulting & Professional" },
  { key: "talent",                   code: "TS · 04", label: "Talent Services" },
];

const SERVICE_LIST = [
  // ── Infrastructure Services ──────────────────────────────────
  {
    category: "infra",
    title: "Design and Deployment",
    description: "Complete network infrastructure design and seamless deployment services tailored to your business needs.",
    icon: designIcon,
    link: "/services/design-and-deployment",
    linkLabel: "Explore Design and Deployment",
  },
  {
    category: "infra",
    title: "Configuration Services & Deployment",
    description: "Deploy new technology confidently with consistent configuration, security first policies, and rollout support. Reduce setup time and prevent misconfigurations.",
    icon: ConfigDeployment,
    link: "/services/Configuration-Services-Deployment",
    linkLabel: "Explore Configuration Services",
  },
  {
    category: "infra",
    title: "Network Audit",
    description: "Comprehensive security and performance audits for your network infrastructure to ensure optimal operation.",
    icon: auditIcon,
    link: "/services/Network-Audit",
    linkLabel: "Explore Network Audit",
  },
  {
    category: "infra",
    title: "Network Solutions",
    description: "24/7 network monitoring and routine assessments to identify and fix issues early. Keep your devices secure and running seamlessly.",
    icon: NetworkSolutions,
    link: "/services/Managed-Network-Solutions",
    linkLabel: "Explore Network Solutions",
  },
  {
    category: "infra",
    title: "Data Center Colocation",
    description: "Colocation strategy that fits your uptime, performance, and growth goals.",
    icon: DataCenterColocation,
    link: "/services/Data-Center-Colocation-services",
    linkLabel: "Explore Data Center Colocation",
  },
  {
    category: "infra",
    title: "Help Finding Ideal Colocation",
    description: "Expert guidance in selecting the perfect colocation facility for your infrastructure and business requirements.",
    icon: colocationIcon,
    link: "/services/Help-finding-Ideal-Colocation",
    linkLabel: "Explore Colocation Guidance",
  },

  // ── Managed Services ─────────────────────────────────────────
  {
    category: "managed",
    title: "Cloud IT Solutions",
    description: "Secure cloud backups, smooth migrations, and reliable ongoing support to keep your business connected and productive.",
    icon: CloudITSolutions,
    link: "/services/cloud-IT-solutions",
    linkLabel: "Explore Cloud IT Solutions",
  },
  {
    category: "managed",
    title: "AI & Automation",
    description: "Boost efficiency with secure AI and automation tools that reduce manual work and improve decision-making.",
    icon: AIandAutomation,
    link: "/services/AI-Automation-Services",
    linkLabel: "Explore AI & Automation",
  },
  {
    category: "managed",
    title: "Cyber Security",
    description: "Protect your organisation with audits, compliance consulting, incident response, and layered security defenses.",
    icon: CyberSecurity,
    link: "/services/Cybersecurity-Services",
    linkLabel: "Explore Cyber Security",
  },
  {
    category: "managed",
    title: "IT Support Services",
    description: "Minimise downtime with 24/7 helpdesk support and proactive device management. Efficient, dependable IT assistance.",
    icon: ITSupportService,
    link: "/services/IT-Managed-Support-Services",
    linkLabel: "Explore IT Support",
  },
  {
    category: "managed",
    title: "Support & Training",
    description: "Ongoing technical support and comprehensive training programs to empower your team and ensure long-term success.",
    icon: supportIcon,
    link: "/services/Support-Training",
    linkLabel: "Explore Support & Training",
  },

  // ── IT Consulting & Professional ─────────────────────────────
  {
    category: "ITConsulting&Professional",
    title: "Strategic IT Consulting",
    description: "Plan, implement, and manage IT projects with expert guidance and smart procurement. Simplify your environment.",
    icon: StrategicITConsulting,
    link: "/services/Strategic-IT-Consulting",
    linkLabel: "Explore Strategic IT Consulting",
  },
  {
    category: "ITConsulting&Professional",
    title: "Business Strategy",
    description: "Strategic IT consulting to align technology with your business goals and drive meaningful digital transformation.",
    icon: strategyIcon,
    link: "/services/Business-Strategy",
    linkLabel: "Explore Business Strategy",
  },
  {
    category: "ITConsulting&Professional",
    title: "Cloud Consulting",
    description: "Cloud strategy, migration, and ongoing support built around your specific business objectives and constraints.",
    icon: cloudConsulting,
    link: "/services/Cloud-Consulting",
    linkLabel: "Explore Cloud Consulting",
  },
  {
    category: "ITConsulting&Professional",
    title: "Cybersecurity Consulting",
    description: "Protect systems, reduce risk, and strengthen your security posture with expert advisory and assessment.",
    icon: CybersecurityConsulting,
    link: "/services/Cybersecurity-Consulting",
    linkLabel: "Explore Cybersecurity Consulting",
  },
  {
    category: "ITConsulting&Professional",
    title: "Infrastructure Consulting",
    description: "Build infrastructure that is easier to run, scale, and recover with a structured modernisation roadmap.",
    icon: InfrastructureConsulting,
    link: "/services/Infrastructure-Consulting",
    linkLabel: "Explore Infrastructure Consulting",
  },
  {
    category: "ITConsulting&Professional",
    title: "Digital Transformation",
    description: "Modernise the way your business works, delivers, and grows through structured transformation planning.",
    icon: DigitalTransformation,
    link: "/services/Digital-Transformation",
    linkLabel: "Explore Digital Transformation",
  },
  {
    category: "ITConsulting&Professional",
    title: "Implementation Services",
    description: "Deliver new systems with less risk and more control structured implementation from planning to handover.",
    icon: ImplementationServices,
    link: "/services/Implementation-Services",
    linkLabel: "Explore Implementation Services",
  },

  // ── Talent Services ──────────────────────────────────────────
  {
    category: "talent",
    title: "Technical Recruiters",
    description: "Find and hire top IT talent for your specialised technology needs with our expert recruitment services.",
    icon: recruiterIcon,
    link: "/services/Technical-Recruiters",
    linkLabel: "Explore Technical Recruiters",
  },
];

// Helper — is the icon value an image path?
function isImageSrc(val) {
  const s = String(val || "");
  return (
    s.includes(".jpg") ||
    s.includes(".jpeg") ||
    s.includes(".png") ||
    s.startsWith("data:image") ||
    s.startsWith("blob:")
  );
}

// ── Component ─────────────────────────────────────────────────────
const Services = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].key);

  const filteredServices = useMemo(
    () => SERVICE_LIST.filter((s) => s.category === activeTab),
    [activeTab]
  );

  const activeTabData = TABS.find((t) => t.key === activeTab);

  // Count per tab for sidebar badge
  const countByTab = useMemo(() => {
    const map = {};
    TABS.forEach((t) => {
      map[t.key] = SERVICE_LIST.filter((s) => s.category === t.key).length;
    });
    return map;
  }, []);

  return (
    <div className="svc-page">

      {/* ── HERO ──────────────────────────────────────────────── */}
      <section className="svc-hero">
        <div className="svc-hero__bg" aria-hidden="true" />
        <div className="svc-hero__inner">
          <div className="svc-hero__eyebrow">
            <span className="live-dot" aria-hidden="true" />
            Service catalog
          </div>
          <h1 className="svc-hero__title">
            Our <em>Services</em>
          </h1>
          <p className="svc-hero__lead">
            Deep expertise, attentive insight, and proven methods applied at the right
            moment to solve your organisation's most critical technology challenges.
          </p>
        </div>
      </section>

      {/* ── BODY: sidebar + content ────────────────────────────── */}
      <div className="svc-body">

        {/* ── SIDEBAR (terminal nav) ─────────────────────────── */}
        <nav className="svc-sidebar" aria-label="Service categories">
          <div className="svc-sidebar__prompt">
            <span className="svc-sidebar__cursor" aria-hidden="true" />
            select_category
          </div>

          <div className="svc-tab-list" role="tablist" aria-label="Service categories">
            {TABS.map((t) => (
              <button
                key={t.key}
                role="tab"
                type="button"
                aria-selected={activeTab === t.key}
                className={`svc-tab${activeTab === t.key ? " active" : ""}`}
                onClick={() => setActiveTab(t.key)}
              >
                <span className="svc-tab__code">{t.code}</span>
                <span className="svc-tab__label">{t.label}</span>
                <span className="svc-tab__count">
                  {countByTab[t.key]} service{countByTab[t.key] !== 1 ? "s" : ""}
                </span>
              </button>
            ))}
          </div>
        </nav>

        {/* ── CONTENT ───────────────────────────────────────────── */}
        <div className="svc-content" role="tabpanel">
          <div className="svc-content__head">
            <span className="svc-content__name">{activeTabData?.label}</span>
            <span className="svc-content__tally">
              {filteredServices.length}&nbsp;service{filteredServices.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="svc-grid">
            {filteredServices.map((service, idx) => (
              <article key={idx} className="svc-card">
                {/* scan-corner amber brackets on hover */}
                <span className="scan-corner tl" aria-hidden="true" />
                <span className="scan-corner tr" aria-hidden="true" />
                <span className="scan-corner bl" aria-hidden="true" />
                <span className="scan-corner br" aria-hidden="true" />

                <div className="svc-card__icon">
                  {isImageSrc(service.icon) ? (
                    <img src={service.icon} alt="" aria-hidden="true" />
                  ) : (
                    <span aria-hidden="true">{service.icon}</span>
                  )}
                </div>

                <h2 className="svc-card__title">{service.title}</h2>
                <p className="svc-card__text">{service.description}</p>

                <div className="svc-card__divider" aria-hidden="true" />

                <Link to={service.link} className="svc-card__link">
                  {service.linkLabel}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M5 12h14M13 5l7 7-7 7" />
                  </svg>
                </Link>
              </article>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Services;